import { createContext, useContext } from 'react';
import type { RoleKey, MountUser } from '@unified-governance/shared';

export interface ShellAuth {
  roles: RoleKey[];
  user: MountUser;
  getAccessToken: (scope: string) => Promise<string>;
}

export const ShellAuthContext = createContext<ShellAuth | null>(null);

export function useShellAuth(): ShellAuth {
  const context = useContext(ShellAuthContext);
  if (!context) {
    throw new Error('useShellAuth must be used within MsalShellAuthProvider');
  }
  return context;
}
